import { createGlobalStyle } from 'styled-components';
import styled, {css, keyframes} from 'styled-components';
import device from './device';

// Image
import { ReactComponent as Wave } from '../Images/waves.svg';
import borderImg from '../Images/borderImg.png';
import marinaxLogo from "../Images/MarinaXword.png";
import bg from '../Images/bg.png';
import mobileMenu from '../Images/mobileMenu.png';
import mobileMenuClose from '../Images/mobileMenuClose.png';
import mobileScrollDown from '../Images/mobileScrollDown.png';

//KeyFrames Animation
const dbUp = keyframes`
  0% {transform: translateY(0vh)}
  100% {transform: translateY(-1vh)}`;

const dbDown = keyframes`
  0% {transform: translateY(0vh)}
  100% {transform: translateY(1vh)}`;

const dbLeft = keyframes`
  0% {transform: translateX(0vw)}
  100% {transform: translateX(-1vw)}`;

const dbRight = keyframes`
  0% {transform: translateX(0vw)}
  100% {transform: translateX(1vw)}`;

const dbGraph = keyframes`
  0% {
    transform: translateY(0vh) scale(1)}
  100% {
    transform: translateY(-2.5vh) scale(1,0)}`; 

const dbFade = keyframes`
  0% {opacity: 0.4}
  100% {opacity: 1}`;

const leftXS = keyframes`
  0% {transform: translateX(0vw)}
  100% {transform: translateX(-5vw)}`;

const rightXS = keyframes`
  0% {transform: translateX(0vw)}
  100% {transform: translateX(3vw)}`;

const upS = keyframes`
  0% {transform: translateY(0vh)}
  100% {transform: translateY(-10vh)}`;

const downS = keyframes`
  0% {transform: translateY(0vh)}
  100% {transform: translateY(10vh)}`;

const leftS = keyframes`
  0% {transform: translateX(0vw)}
  100% {transform: translateX(-10vw)}`;

const rightS = keyframes`
  0% {transform: translateX(0vw)}
  100% {transform: translateX(10vw)}`;

const upM = keyframes`
  0% {transform: translateY(0vh)}
  100% {transform: translateY(-15vh)}`;

const downM = keyframes`
  0% {transform: translateY(0vh)}
  100% {transform: translateY(15vh)}`;

const leftM = keyframes`
  0% {transform: translateX(0vw)}
  100% {transform: translateX(-15vw)}`;

const rightM = keyframes`
  0% {transform: translateX(0vw)}
  100% {transform: translateX(15vw)}`;

const upL = keyframes`
  0% {transform: translateY(0vh)}
  100% {transform: translateY(-20vh)}`

const downL = keyframes`
  0% {transform: translateY(0vh)}
  100% {transform: translateY(20vh)}`;

const leftL = keyframes`
  0% {transform: translateX(0vw)}
  100% {transform: translateX(-20vw)}`

const rightL = keyframes`
0% {transform: translateX(0vw)}
100% {transform: translateX(20vw)}`;

const spin = keyframes`
  0% {transform: rotate(0deg)}
  100% {transform: rotate(360deg)}`

const fadeIn = keyframes`
  0% {opacity: 0}
  100% {opacity: 1}`

const float = keyframes`
  0% {transform: translateY(0vh)}
  50% {transform: translateY(2vh)}
  100% {transform: translateY(0vh)}`

const flash = keyframes`
  0% {opacity: 1}
  2% {opacity: 0}
  4% {opacity: 1}
  6% {opacity: 0}
  8% {opacity: 1}
  10% {opacity: 0}
  12% {opacity: 1}
  100% {opacity: 1}`

const enlarge = keyframes`
  0% {font-size: 2vmin}
  50% {font-size: 4vmin}
  100% {font-size: 2.8vmin}`;

const waves2Ani = keyframes`
  0% { transform: skewX(-50deg) }
  100% { transform: skewX(50deg)}`;

//Css styles web pages
const globalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    border: 0;
    box-sizing: border-box;
    font-family: Arial, Helvetica, sans-serif;
    color: white;
    letter-spacing: 0.04rem;
    background-color: rgb(0, 1, 22);
    overflow: hidden;
  }
`;

  const styledMobileMenu = styled.button`
    display: ${props => (props.mobile ? "none" : "inline-flex")};
    background: url(${mobileMenu});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    margin-top: 4%;
    margin-right: 4%;
    padding: 0;
    border: 0;
    top: 0;
    right: 0;
    position: fixed;
    height: 8vmin;
    width: 8vmin;
    cursor: pointer;
    z-index: 3;
    @media ${device.laptop} {
      display: none;
    }
  `;

  const styledMobileMenuClose = styled.button`
    display: ${props => (props.mobile ? "inline-flex" : "none")};
    background: url(${mobileMenuClose});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    margin-top: 4%;
    margin-right: 4%;
    padding: 0;
    border: 0;
    top: 0;
    right: 0;
    position: fixed;
    height: 8vmin;
    width: 8vmin;
    cursor: pointer;
    z-index: 3;
    @media ${device.laptop} {
      display: none;
    }
  `;

const styledTopMenu = styled.div`
  display: ${props => (props.mobile ? "grid" : "none")};
  width: 100%;
  height: 100%;
  position: fixed;
  place-items: center;
  text-align: center;
  z-index: 2;
  background-color: rgb(34, 16, 56, 0.97);
  @media ${device.laptop} {
    display: inline-block;
    background: none;
    margin: 2.5% auto;
    width: 70%;
    height: auto;
    top: 0;
    left: 0;
    right: 0;
  }
`;

const styledTopMenuSub = styled.h4` 
  font-size: 3vh;
  position: relative;
  display: inline-flex;
  margin: auto 4%;
  cursor: pointer;
  :after {
    content: '';
    position: absolute;
    left:0; right:0%;
    top: 100%;
    margin:0.5vmin auto;
    width:40%;
    height:18%;
    background:rgb(126, 169, 255);
    opacity: 0;
  }
  :hover {
    color: rgb(126, 169, 255);
  :after{
    transition: 1s ease;
    opacity: 1;
  }
  }
  ${props =>
    props.active &&
    css`
      color: rgb(126, 169, 255);
      :after {
        transition: 1s ease;
        opacity: 1;
      }
    `}
    @media ${device.laptop} {
    font-size: 90%;
    }
  `;
  
const styledNav = styled.div`
  display: flex;
  background: url(${mobileScrollDown});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 4% auto;
  padding: 0;
  border: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  height: 8vmin;
  width: 8vmin;
  z-index: 1;
  transition: 0.5s ease;
  transform: ${props => props.active && 'rotateX(180deg)' };
  cursor: pointer;

  @media ${device.laptop} {
    left: -85%;
    bottom: 15%;
    padding: 0;
    width: 40vw;
    position: fixed;
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    place-content: center;
    transform: rotate(270deg);
    color: RGB(236, 140, 253);
    background: none;
  }
`;

const styledNavSubText = styled.p`
  display: none;
  margin: 1.5%;
  font-size: 0.8rem;
  align-self: center;
  opacity: ${props => props.active ? '1' : '0'};
 @media ${device.laptop} {
   display: flex;
 }
`;

const styledNavSub = styled.p`
display: none;
align-self: center;
margin: 0.1rem;
height: 0.8rem;
width: 0.9rem;

background-color: RGB(129, 120, 140);
transition: 0.8s ease;
${props =>
  props.active &&
  css`
    width: 4.4vmin;
    background-color: RGB(236, 140, 253);
  `}
@media ${device.laptop} {
   display: inline-flex;
 }
`;

const styledDiv = styled.div`
  height: 100vh;
  width: 100%;
  background: none;
  box-sizing: border-box;
  color: white;

  display: flex;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;

  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  -webkit-flex-flow: column nowrap;
  -webkit-align-items: center;
`;

const SectionBg = styled.div`
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  position: fixed;
  z-index: -1;
  pointer-events: none;

  background-image: url(${bg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const Section1 = styled.div`
  height: 100vh;
  width: 100%;
  box-sizing: border-box;
  color: white;

  display: flex;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;

  flex-flow: column nowrap;
  place-content: center;
  place-items: center;
  box-sizing: border-box;

  -webkit-flex-flow: column nowrap;
  -webkit-align-items: center;
  overflow: hidden;

  section {
    height: auto;
    width: 50vw;
    font-size: 74%;
    position: absolute;
    text-align: center;
    text-shadow: 1px 1px 3px #fff;
    @media ${device.laptop} {
      text-shadow: none;
      width: 35vw;
      font-size: 2.4vmin;
    }
  }
`;

const Section2 = styled.div`
  height: 100vh;
  width: 100%;
  box-sizing: border-box;
  display: grid;
  grid: 10% 20% 20% 20% / 65%;
  grid-auto-flow: column;
  place-content: center;
  place-items: center;
  h1 {
    display: grid;
    letter-spacing: 0.2em;
    grid-area: 1/1/2/2;
    place-self: center;
    color: rgb(224, 64, 251);
    font-size: 5vmin;
  }
  section {
    display: grid;
    box-sizing: border-box;
    border: 2vmax solid transparent;
    border-image: url(${borderImg}) 8% 10% round;
    padding: 1vmax;
    height: 90%;
    width: 90%;
    place-items: center;
    text-align: center;
    font-size: 2.2vmin;
    p.s2Heading {
      display: grid;
      place-self: center;
      margin: 0;
      padding: 0;
      color: rgb(123, 164, 249);
      font-size: 2.5vmin;
    }
    img {
      display: none;
    }
  }
  p {
    display: none;
  }

  @media ${device.laptop} {
    font-size: 0.8rem;
    grid: 25% 60% 15% / repeat(3, 23%);
    h1 {
      font-size: 3.8vmin;
      grid-area: 1/1/2 / span 3;
      place-self: end start;
    }
    section {
      animation: ${downL} 1s ease reverse backwards, ${fadeIn} 2s cubic-bezier(0.58, 0.1, 0.85, 0.05) backwards;
      font-size: 1.8vmin;
      p.s2Heading {
        display: none;
      }
      img {
        display: grid;
        object-fit: cover;
        max-width: 100%;
        max-height: 100%;
        align-self: end;
        animation: ${downS} 1s ease 0.5s reverse backwards, ${fadeIn} 1s cubic-bezier(0.58, 0.1, 0.85, 0.05) backwards;
      }
    }
    p {
      display: grid;
      grid-area: 3/1 / span 3/4;
      align-self: start;
      animation: ${downL} 1s ease reverse backwards, ${fadeIn} 2s cubic-bezier(0.58, 0.1, 0.85, 0.05) backwards;
    }
  }
`;

const Section3 = styled.div`
  height: 100vh;
  width: 100%;
  box-sizing: border-box;

  display: grid;
  grid: 10% 12% 12% 30% / 90%;
  grid-auto-flow: column;
  place-content: center;
  place-items: center;
  img.s3-dashboard-mobile {
    display: grid;
    grid-area: 4/1/5/2;
    width: 90%;
    height: 90%;
    object-fit: contain;
  }
  section.s3-dashboard {
    display: none;
  }
  h2 {
    margin: 0;
    align-self: center;
    font-size: 5vmin;
    letter-spacing: 0.2rem;
    color: rgb(224, 64, 251);
  }
  section {
    text-align: center;
    h4 {
      margin: 1%;
      font-size: 3vmin;
      color: rgb(126, 169, 255);
    }
    p {
      margin: 1%;
      font-size: 2vmin;
    }
  }
  @media ${device.laptop} {
    grid: 18% 12% 12% / 40% 35%;
    grid-column-gap: 2%;
    img.s3-dashboard-mobile {
      display: none;
    }
    section.s3-dashboard {
      position: relative;
      display: grid;
      grid-area: 1/1/4/2;
      place-items: center;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      .db_bg {
        position: absolute;
        height: auto;
        width: 50vmin;
        animation: ${dbFade} 1s linear infinite alternate;
      }
      .db_person {
        position: absolute;
        height: auto;
        margin: 3.4vmin 0 0 -1.4vmin;
        width: 15.1vmin;
        z-index: 1;
      }
      .db_center1overlay {
        position: absolute;
        width: 5.5vmin;
        height: 2vmin;
        margin: -19vmin 0 0 -7vmin;
        z-index: 1;
        background-color: rgb(61, 45, 101);
        animation: ${dbGraph} 2s linear infinite alternate; 
      }
      .db_center1 {
        position: absolute;
        margin: -17.5vmin 0 0 -1.5vmin;
        height: auto;
        width: 12.3vmin;
        animation: ${dbUp} 2s linear infinite alternate;
      }
      .db_left1 {
        position: absolute;
        margin: -15.9vmin 0 0 -29vmin;
        height: auto;
        width: 5.1vmin;
        animation: ${dbLeft} 2s linear infinite alternate;
      }
      .db_left2 {
        position: absolute;
        margin: 0.2vmin 0 0 -42vmin;
        height: auto;
        width: 5.2vmin;
        animation: ${dbLeft} 2s linear infinite alternate;
      }
      .db_left3 {
        position: absolute;
        margin: 7vmin 0 0 -24vmin;
        height: auto;
        width: 6vmin;
        animation: ${dbLeft} 2s linear infinite alternate;
      }
      .db_left4 {
        position: absolute;
        margin: 18.3vmin 0 0 -34.5vmin;
        height: auto;
        width: 5.5vmin;
        animation: ${dbLeft} 2s linear infinite alternate;
      }
      .db_right1 {
        position: absolute;
        margin: -18.5vmin 0 0 28vmin;
        height: auto;
        width: 4.8vmin;
        animation: ${dbRight} 2s linear infinite alternate;
      }
      .db_right2 {
        position: absolute;
        margin: 3.4vmin 0 0 20.5vmin;
        height: auto;
        width: 7vmin;
        animation: ${dbRight} 2s linear infinite alternate;
      }
      .db_right3 {
        position: absolute;
        margin: 17vmin 0 0 29.8vmin;
        height: auto;
        width: 6.5vmin;
        animation: ${dbRight} 2s linear infinite alternate;
      }
    }
    h2 {
      justify-self: start;
      animation: ${upL} 1s ease reverse backwards, ${fadeIn} 1s cubic-bezier(0.58, 0.1, 0.85, 0.05) backwards;
    }
    section {
      text-align: left;
      place-self: center start;
      animation: ${rightL} 1s ease reverse, ${fadeIn} 1s cubic-bezier(0.58, 0.1, 0.85, 0.05);
      h4 {
        margin: 0;
      }
    }
  }
`;

const Section4 = styled.div`
  height: 100vh;
  width: 100%;
  box-sizing: border-box;
  display: grid;
  grid: 15% repeat(3, 16%) 10% / 80%;
  grid-auto-flow: column;
  place-content: center;
  place-items: center;

  section.s4first {
    color: rgb(224, 64, 251);
    letter-spacing: 0.4vmin;
    h3 {
      margin-bottom: 2%;
      text-align: center;
      font-size: 2.5vmin;
    }
    h2 {
      margin-top: 2%;
      text-align: center;
      font-size: 4.5vmin;
    }
  }
  section.s4second {
    height: 100%;
    width: 100%;
    text-align: center;
    img {
      height: 45%;
      width: 45%;
      object-fit: contain;
    }
    p:first-of-type {
      margin-top: 0;
      font-size: 2.7vmin;
      color: rgb(126, 169, 255);
    }
    p {
      margin: 1%;
      font-size: 2.2vmin;
      animation: none;
    }
  }
  p.s4last {
    font-size: 2.8vmin;
    text-align: center;
    color: rgb(224, 64, 251);
  }
  @media ${device.laptop} {
    grid: 20% 30% 10% / repeat(3, 22%);
    grid-auto-flow: row;

    section.s4first {
      grid-area: 1/1/2/4;
      place-self: center start;
      animation: ${upL} 1s ease reverse, ${fadeIn} 1s cubic-bezier(0.58, 0.1, 0.85, 0.05);
      h3 {
        margin: 0%;
        text-align: left;
      }
      h2 {
        margin: 0;
        text-align: left;
        font-size: 9vmin;
      }
    }
    section.s4second {
      img {
        margin: 0;
        width: 30%;
        height: 30%;
        object-fit: contain;
        animation: ${spin} 6s linear infinite;
      }
      p:first-of-type {
        margin-top: 3vmin;
        font-size: 2vmin;
      }
      p {
        margin: 2%;
        font-size: 1.6vmin;
        animation: ${downL} 1s ease reverse backwards, ${fadeIn} 1s cubic-bezier(0.58, 0.1, 0.85, 0.05) backwards;
      }
    }
    p.s4last {
      grid-area: 3/1/4/4;
      margin: auto;
      animation: ${enlarge} 1.5s linear 1.5s both, ${fadeIn} 1.5s cubic-bezier(0.58, 0.1, 0.85, 0.05) 1s both;
    }
  }
`;

const Section5 = styled.div`
  height: 100vh;
  width: 100%;
  box-sizing: border-box;

  display: grid;
  grid: 15% 30% 35% 20% / 1fr;

  section {
    grid-area: 2/1/3 /2;
    place-self: center;
    text-align: center;
    width: 76%;
    p {
      margin: 0;
      font-size: 4vmin;
    }
    p:last-of-type {
      margin: 4% 0% 4% 0%;
      color: rgb(224, 64, 251);
      height: 4vmin;
      font-size: 2.8vmin;
      font-weight: bold;
      animation: ${enlarge} 1s ease 0.8s both, ${fadeIn} 2s ease 0.8s both;
    }
    button {
      background-color: transparent;
      border: 0.08rem solid rgb(224, 64, 251);
      border-radius: 25px;
      padding: 2vmin 0.5vmin;
      font-size: 2.5vmin;
      z-index: 1;
      a {
        height: 4vmin;
        font-size: 2.5vmin;
        padding: 1.5vmin 3.5vmin;
        text-decoration: none;
        color: white;
        background-color: rgb(224, 64, 251);
        border-radius: 20px;
        z-index: 2;
      }
    }
  }
  .robotcontainer {
    position: relative;
    display: grid;
    grid-area: 3/1/4/2;
    place-items: center;
    box-sizing: border-box;
    .laptopBG {
      position: absolute;
      height: auto;
      width: 39vmin;
    }
    .robot {
      position: absolute;
      margin: -16vmin 0 0 1vmin;
      height: auto;
      width: 7.5vmin;
      animation: ${float} 3s ease infinite;
    }
    .beam {
      position: absolute;
      margin: -17.5vmin 0 0 2vmin;
      height: auto;
      width: 28vmin;
      z-index: 1;
      animation: ${flash} 2s ease infinite;
    }
    .ray1 {
      position: absolute;
      margin: -9.5vmin 0 0 -26.5vmin;
      height: auto;
      width: 1.7vmin;
      animation: ${upS} 2s ease-in-out -6s infinite, ${fadeIn} 1s linear -6s infinite alternate;
    }
    .ray2 {
      position: absolute;
      margin: 11vmin 0 0 -2.2vmin;
      height: auto;
      width: 1vmin;
      animation: ${upS} 2s ease-in-out -3s infinite, ${fadeIn} 1s linear -3s infinite alternate;
    }
    .ray3 {
      position: absolute;
      margin: -13.9vmin 0 0 27.3vmin;
      height: auto;
      width: 1.8vmin;
      animation: ${upS} 2s ease-in-out 1s infinite, ${fadeIn} 1s linear 1s infinite alternate;
    }
    .square1 {
      position: absolute;
      margin: -23.5vmin 0 0 -29.4vmin;
      height: auto;
      width: 6.5vmin;
    }
    .square2 {
      position: absolute;
      margin: -15vmin 0 0 40vmin;
      height: auto;
      width: 6.4vmin;
    }
    .square3 {
      position: absolute;
      margin: 9vmin 0 0 -55vmin;
      height: auto;
      width: 11vmin;
    }
    .square4 {
      position: absolute;
      margin: 22vmin 0 0 40vmin;
      height: auto;
      width: 9vmin;
    }
    .bubble1box {
      position: absolute;
      margin: 5vmin 0 0 -34vmin;
      animation: ${upL} 2.5s infinite -3s cubic-bezier(0.02, 0.01, 0.21, 1);
    }
    .bubble1 {
      height: auto;
      width: 5vmin;
      z-index: -1;
      animation: ${leftS} 2.5s infinite -3s cubic-bezier(0.3, 0.27, 0.07, 1.64), ${fadeIn} 2.5s linear -3s infinite alternate;
    }
    .bubble2box {
      position: absolute;
      margin: 2vmin 0 0 -26.5vmin;
      animation: ${upL} 7s infinite -5s cubic-bezier(0.02, 0.01, 0.21, 1);
    }
    .bubble2 {
      height: auto;
      width: 2.4vmin;
      z-index: -1;
      animation: ${leftXS} 7s infinite -5s cubic-bezier(0.3, 0.27, 0.07, 1.64), ${fadeIn} 7s linear -5s infinite alternate;
    }
    .bubble3box {
      position: absolute;
      margin: -9.5vmin 0 0 13vmin;
      animation: ${upM} 4s infinite -3s cubic-bezier(0.61, 2, 0.5, 0);
    }
    .bubble3 {
      height: auto;
      width: 2.3vmin;
      z-index: -1;
      animation: ${rightXS} 4s infinite -3s cubic-bezier(0.93, 1.91, 0, 0.2), ${fadeIn} 4s linear -3s infinite alternate;
    }
    .bubble4box {
      position: absolute;
      margin: 1vmin 0 0 35vmin;
      animation: ${upL} 5.5s infinite -3s cubic-bezier(0.53, 0.08, 0.11, 1.07);
    }
    .bubble4 {
      height: auto;
      width: 4.5vmin;
      z-index: -1;
      animation: ${rightS} 5.5s infinite -3s cubic-bezier(0.42, 0, 0.58, 1), ${fadeIn} 5.5s linear -3s infinite alternate;
    }
  }
  @media ${device.laptop} {
    grid: 20% 60% 20% / repeat(2, 1fr);
    section {
      grid-area: 2/1/3/2;
      place-self: center end;
      text-align: left;
      width: 78%;
    }
    .robotcontainer {
      grid-area: 2/2/3/3;
      height: 100%;
      width: 100%;
      .laptopBG {
      }
    }
  }
`;

const styledCanvas = styled.canvas`
	position: absolute;
	height: 100vh;
	width: 100%;
`

const styledWaves = styled.div`
  position: relative;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  grid-area: 4/1/5/2;
  margin: 0;
  padding: 0;
  z-index: -1;
  @media ${device.laptop} {
    grid-area: 3/1/4/3;
  }
`;

const Waves = styled(Wave)`
  position: absolute;
  height: 70%;
  width: 100%;
  bottom: 0;
  /*Fix for safari gap*/
  min-height: 100px;
  max-height: 150px;

  .parallax > use {
    animation: move-forever 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;
  }
  .parallax > use:nth-child(1) {
    animation-delay: -2s;
    animation-duration: 7s;
  }
  .parallax > use:nth-child(2) {
    animation-delay: -3s;
    animation-duration: 10s;
  }
  .parallax > use:nth-child(3) {
    animation-delay: -4s;
    animation-duration: 13s;
  }
  .parallax > use:nth-child(4) {
    animation-delay: -5s;
    animation-duration: 20s;
  }
  @keyframes move-forever {
    0% {
      transform: translate3d(-90px, 0, 0);
    }
    100% {
      transform: translate3d(85px, 0, 0);
    }
  }
`;

const styledDigitalParticles = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`; 

const Logo = styled.img.attrs({
  src: marinaxLogo
})`
  max-width: 100%;
  max-height: 100%;
`; 

export {
    globalStyle,
    styledTopMenu,
    styledTopMenuSub,
    styledMobileMenu,
    styledMobileMenuClose,
    styledNav,
    styledNavSubText,
    styledNavSub,
    styledDiv,
    SectionBg,
    Section1,
    Section2,
    Section3,
    Section4,
    Section5,
    styledCanvas,
    styledWaves,
    Waves,
    styledDigitalParticles,
    Logo
};